import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PropCard from '../../components/PropCard';
import { getApprovedPropertyAction } from "../../redux/actions/propertyActions";
import { FiWifiOff } from 'react-icons/fi';

const Home = () => {
  const dispatch = useDispatch()

  const getApprovedProperty = useSelector(state => state.getApprovedProperty)
  const { data, error } = getApprovedProperty

  useEffect(() => {
    document.title = "Island Luxury"
    dispatch(getApprovedPropertyAction())
  }, [dispatch])

  return (
    <div id="home">
      <Header />
      <main>
        <section className="landing-area">
          <div className="landing-container container">
            <h1>varieties of <span>property</span> listings ranging from Flats, <span>Houses</span>, Land & <span>Commercial</span> Property all for lease, Rent and Sale</h1>
            <p>We bring a special blend of carefully curated property listings to your fingertips.</p>
            <NavLink to="/signup">Post A Property for free</NavLink>
          </div>
        </section>
        <section className="available-property container">
          <h2>Available Property</h2>
          {error ? 
            <div className="error-msg">
              <FiWifiOff size={65} />
              <p>You're offline. Check your connection.</p>
            </div>
          :
            <div className="available-property_cards">
              {data?.data?.slice(0, 6)?.map((item, index) => 
                <PropCard 
                  key={index}
                  id={item._id}
                  img={item.firstImage}
                  category={item.category}
                  title={item.title}
                  price={item.price}
                  beds={item.bedrooms}
                  baths={item.bath}
                  address={item.state} />
              )}
            </div>
            }
          <div className="ap_cards-see-more">
            <NavLink to="/property">See More</NavLink>
          </div>
        </section>
        <Footer />
      </main>
    </div>
  )
}

export default Home;